import { useRequest } from 'ahooks'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getPointPermission } from '@/components'
import { JQLTable, JiraResp } from '@/components/jql/jql-table.component'
import { JiraColumnProps } from '@/modules/project/project-detail/project-jql/project-jql-table-config.component'
import { PAGE_RESOURCE_POINTS_ENUM, ResourceType } from '@/schemas'

import { Devlop } from '../../devlop.schema'
import { DevlopJQLEdit } from './devlop-jql-edit.component'
import { DevlopJqlTableConfig } from './devlop-jql-table-config.component'

interface DevlopJQLProps {
  devlop: Devlop
}

export const DevlopJQLContainer: React.FC<DevlopJQLProps> = ({ devlop }) => {
  const { t } = useTranslation()
  const { selfId, jql: initialJql } = devlop
  const { editable: editableConfig } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.需求与问题_配置, devlop.permissions)
  const { editable: editableContent } = getPointPermission(
    PAGE_RESOURCE_POINTS_ENUM.需求与问题_内容,
    devlop.permissions
  )
  const [editVisible, setEditVisible] = React.useState(false)
  const [configVisible, setConfigVisible] = React.useState(false)
  const [jql, setJql] = React.useState(initialJql)

  const {
    data: jiraTableData,
    run: jiraTableRefresh,
    loading: jiraTableLoading,
  } = useRequest<JiraColumnProps[]>(() => ({
    url: '/api/project/getJiraTableConfig',
    method: 'get',
    params: {
      selfId,
      type: ResourceType.DEVLOP,
    },
  }))

  const { data, loading, run } = useRequest<JiraResp>(
    {
      url: '/api/project/getJiraAndUpdate',
      params: {
        selfId: devlop.selfId,
        type: ResourceType.DEVLOP,
        jql,
      },
    },
    {
      manual: true,
      refreshOnWindowFocus: false,
      debounceInterval: 800,
    }
  )

  // ready和refreshDeps配合时只会在第一次生效
  // https://github.com/alibaba/hooks/issues/468
  React.useEffect(() => {
    if (jql) {
      run()
    }
  }, [jql])

  const issues = data?.issues || []
  const hasBugField = issues.some((issue) => issue.bugResolved !== 'N/A')
  const hasReleaseStatusField = issues.some((issue) => issue.isReleaseType)

  const dropdown = (
    <div className='flex mb-4 justify-between'>
      <Button type='primary' disabled={!editableConfig} onClick={() => setConfigVisible(true)}>
        {t('list config')}
      </Button>
      {/* <Dropdown overlay={menu}> */}
      <Button type='primary' disabled={!editableContent} onClick={() => setEditVisible(true)}>
        {t('associate jira')}
      </Button>
      {/* </Dropdown> */}
    </div>
  )

  const table = jql && (
    <JQLTable
      columns={jiraTableData || []}
      issues={issues}
      loading={loading || jiraTableLoading}
      entity={{ name: devlop.name, type: ResourceType.DEVLOP }}
    />
  )

  return (
    <div>
      {dropdown}
      {table}
      <DevlopJQLEdit
        columns={jiraTableData || []}
        selfId={selfId}
        jql={jql}
        onSuccess={setJql}
        visible={editVisible}
        setVisible={setEditVisible}
        devlop={devlop}
      />
      <DevlopJqlTableConfig
        columns={jiraTableData || []}
        selfId={selfId}
        visible={configVisible}
        setVisible={setConfigVisible}
        refresh={jiraTableRefresh}
        hasBugField={hasBugField}
        hasReleaseStatusField={hasReleaseStatusField}
      />
    </div>
  )
}
